import { Outlet, useLocation } from 'react-router-dom';

import consumerAuthImage from '@/assets/consumer-auth.png';
import merchantAuthImage from '@/assets/merchant-auth.png';

const AuthLayout = () => {
	const location = useLocation();

	// Check if the current route is a consumer route (customer-sign-in or customer-sign-up)
	const isConsumerRoute = location.pathname.includes('customer');
	const brandImage = isConsumerRoute ? consumerAuthImage : merchantAuthImage;

	return (
		<div className="flex w-full">
			<div className="md:flex justify-center items-center hidden w-full md:w-[50%] p-8">
				<div className="bg-white rounded-2xl glassy-shadow-inset-inward p-8 max-w-xl w-full h-2/3 flex items-center justify-center">
					<img
						src={brandImage}
						alt="Haggle logo"
						className="object-contain w-full h-auto"
						data-testid="home-image"
					/>
				</div>
			</div>

			<div className="flex items-center w-full h-full md:w-[45%]">
				<div className="w-full h-full flex items-center">
					<Outlet />
				</div>
			</div>
		</div>
	);
};

export default AuthLayout;
